import Swiper from 'swiper';
import { Pagination, Autoplay } from 'swiper/modules';

// Mobile Menu Collapse
const mobileMenuTrigger = document.querySelector('.site-header .menu-trigger');
const mobileMenu = document.querySelector('.site-header .primary-menu');
mobileMenuTrigger.addEventListener('click', function (){
  mobileMenu.classList.toggle('shown');
  mobileMenuTrigger.querySelector('.icon').classList.toggle('icon-burger');
  mobileMenuTrigger.querySelector('.icon').classList.toggle('icon-close');
  document.querySelector('body').classList.toggle('overflow-y-hidden');
});

// Mobile Menu Dropdown
const parentMenuItems = document.querySelectorAll('.site-header .menu-item-has-children > a');
if ( parentMenuItems ) {
  parentMenuItems.forEach( parent => {
    parent.addEventListener('click', function (event){
      if ( window.innerWidth < 1024 ) {
        event.preventDefault();
        this.parentElement.querySelector('.sub-menu').classList.toggle('shown');
        this.parentElement.classList.toggle('active');
      }
    });
  });
}


// Shrink Header on Scroll
let scrollpos = window.scrollY;
const header = document.querySelector(".site-header");
//const headerHeight = header.offsetHeight;

function compactHeader() {
  if (scrollpos >= 10 /* headerHeight */) {
    header.classList.add("compact")
  }
  else {
    header.classList.remove("compact")
  }
}

window.addEventListener('scroll', function() {
  scrollpos = window.scrollY;
  compactHeader();
});
window.onload = (event) => {
  compactHeader();
};


// Preloader Modal
function splashModalWorkflow() {
  const documentBody = document.querySelector('body');
  const modalOverlay = document.getElementById('splashModalOverlay');
  const modalWrapper = document.getElementById('splashModalWrapper');
  modalOverlay.classList.remove('hidden');
  modalWrapper.classList.remove('hidden');
  documentBody.classList.add('overflow-hidden');
  if ( ! splashModal.classList.contains('show-on-load') ) {
    setTimeout(() => {
      document.addEventListener('click', function(event) {
        if (!document.getElementById('splashModal').contains(event.target) && !modalWrapper.classList.contains('hidden') ) {
          modalOverlay.classList.add('hidden');
          modalWrapper.classList.add('hidden');
          documentBody.classList.remove('overflow-hidden');
        }
      }, { once: true });
    }, "200");
  }
}
const splashModal = document.getElementById('splashModal');
if ( splashModal ) {
  // Show Splash Modal on page load
  if ( splashModal.classList.contains('show-on-load') ) {
    splashModalWorkflow();
  }
  // Show Splash Modal on opener link click
  const splashModalOpener = document.querySelector('.splash-modal-opener a');
  if ( splashModalOpener ) {
    splashModalOpener.addEventListener('click', function (event) {
      event.preventDefault();
      splashModalWorkflow();
    });
  }
}


// Simple Swiper
const simpleSwiper = new Swiper('.simple-swiper', {
  modules: [Pagination, Autoplay],
  spaceBetween: 0,
  slidesPerView: 1,
  slidesPerGroup: 1,
  grabCursor: true,
  pagination: {
    el: '.simple-swiper-pagination',
    type: 'bullets',
    clickable: true,
  },
  autoplay: {
    delay: 5000,
    disableOnInteraction: false,
  },
});

// Post Swiper
const postSwiper = new Swiper('.post-swiper', {
  modules: [Pagination, Autoplay],
  spaceBetween: 0,
  slidesPerView: 1,
  slidesPerGroup: 1,
  grabCursor: true,
  breakpoints: {
    640: {
      slidesPerView: 2,
      slidesPerGroup: 2,
      spaceBetween: 36,
    },
    1024: {
      slidesPerView: 2,
      slidesPerGroup: 2,
      spaceBetween: 56,
    },
    1280: {
      slidesPerView: 3,
      slidesPerGroup: 3,
      spaceBetween: 56,
    },
  },
  pagination: {
    el: '.post-swiper-pagination',
    type: 'bullets',
    dynamicBullets: true,
    dynamicMainBullets: 2,
    clickable: true,
  },
  autoplay: {
    delay: 5000,
    disableOnInteraction: false,
  },
});


// Promo Swiper
const promoSwiper = new Swiper('.promo-swiper', {
  modules: [Pagination, Autoplay],
  spaceBetween: 16,
  slidesPerView: "auto",
  slidesPerGroup: 1,
  grabCursor: true,
  breakpoints: {
    640: {
      slidesPerView: 2,
      slidesPerGroup: 2,
      spaceBetween: 20,
    },
    1024: {
      slidesPerView: 2,
      slidesPerGroup: 2,
      spaceBetween: 36,
    },
    1280: {
      slidesPerView: 3,
      slidesPerGroup: 3,
      spaceBetween: 36,
    },
  },
  pagination: {
    el: '.promo-swiper-pagination',
    type: 'bullets',
    dynamicBullets: true,
    dynamicMainBullets: 2,
    clickable: true,
  },
  autoplay: {
    delay: 5000,
    disableOnInteraction: false,
  },
});


// Equalize Slides Height
function equalizepostSwiperHeight() {
  document.querySelectorAll('.post-equal-height').forEach(row => {
    const postTitles = row.querySelectorAll('.slide-title');
    let maxHeight = 0;
    postTitles.forEach(title => {
      title.style.height = 'auto';
    });
    postTitles.forEach(title => {
      maxHeight = title.offsetHeight > maxHeight ? title.offsetHeight : maxHeight;
    });
    postTitles.forEach(title => {
      title.style.height = maxHeight + 'px';
    });
    const postExcerpts = row.querySelectorAll('.slide-text');
    maxHeight = 0;
    postExcerpts.forEach(excerpt => {
      excerpt.style.height = 'auto';
    });
    postExcerpts.forEach(excerpt => {
      maxHeight = excerpt.offsetHeight > maxHeight ? excerpt.offsetHeight : maxHeight;
    });
    postExcerpts.forEach(excerpt => {
      excerpt.style.height = maxHeight + 'px';
    });
  });
}
equalizepostSwiperHeight();

window.onresize = function (){
  setTimeout(() => {
    equalizepostSwiperHeight();
  }, "200");
}

// Collapsible text
const collapsibleBlocks = document.querySelectorAll('.collapsible');
if ( collapsibleBlocks.length ) {
  collapsibleBlocks.forEach( collapsibleBlock => {
    collapsibleBlock.querySelector('.header').addEventListener('click', function (){
      this.classList.toggle('active');
      collapsibleBlock.querySelector('.content').classList.toggle('hidden');
    });
  });
}


// Tab Navigation
const tabbedContentSections = document.querySelectorAll('.tabbed-content');
if ( tabbedContentSections.length ) {
  tabbedContentSections.forEach( tabbedContentSection => {
    tabbedContentSection.querySelectorAll('nav.tabs a').forEach( tabLink => {
      tabLink.addEventListener('click', function (event){
        event.preventDefault();
        const tabTarget = tabLink.dataset.tabTarget;
        tabbedContentSection.querySelectorAll('.tab-pane').forEach( pane => {
          pane.classList.remove('active');
        });
        tabbedContentSection.querySelector('#'+tabTarget).classList.add('active');
        tabbedContentSection.querySelectorAll('.tabs a').forEach( link => {
          link.classList.remove('active', 'text-default');
          link.classList.add('text-pale-pink');
        });
        tabLink.classList.add('active', 'text-default');
        tabLink.classList.remove('text-pale-pink');
        const shop = tabLink.dataset('shop');
        alert('?');
      });
    });
  });
}

// Floorplan
const floorPlans = document.querySelectorAll('.floorplan-floor');
if ( floorPlans.length ) {
  floorPlans.forEach( floor => {
    floor.querySelectorAll('.floorplan-shops a').forEach( link => {
      link.addEventListener('click', function (event){
        event.preventDefault();
        const shopID = link.dataset.shop;
        floor.querySelectorAll('.floorplan-shop-markers .floorplan-shops--shop-marker').forEach( marker => {
          marker.classList.remove('active');
        });
        const activeMarker = floor.querySelector('.floorplan-shop-markers .shop-' + shopID);
        activeMarker.classList.add('active');
        floor.querySelectorAll('.floorplan-shops a').forEach( link => {
          link.classList.remove('active', 'text-dark-pink');
        });
        link.classList.add('active', 'text-dark-pink');
        activeMarker.scrollIntoView({ block: "center" });
      });
    });
  });
}

// Videos
var videos = document.getElementsByTagName("video");
function checkScroll() {
  var fraction = 0.8; // Play when 80% of the player is visible.

  for(var i = 0; i < videos.length; i++) {

    var video = videos[i];

    var x = video.offsetLeft, y = video.offsetTop, w = video.offsetWidth, h = video.offsetHeight, r = x + w, //right
      b = y + h, //bottom
      visibleX, visibleY, visible;

    visibleX = Math.max(0, Math.min(w, window.pageXOffset + window.innerWidth - x, r - window.pageXOffset));
    visibleY = Math.max(0, Math.min(h, window.pageYOffset + window.innerHeight - y, b - window.pageYOffset));

    visible = visibleX * visibleY / (w * h);

    if (visible > fraction) {
      video.play();
    } else {
      video.pause();
    }

  }
}

window.addEventListener('scroll', checkScroll, false);
window.addEventListener('resize', checkScroll, false);
/*for (video of document.getElementsByTagName("video")) {
  video.setAttribute("playsinline", "");
  video.setAttribute("muted", "");
  video.play();
}*/


// Show more posts
const postGrids = document.querySelectorAll('.posts-grid');
if ( postGrids.length ) {
  postGrids.forEach( postGrid => {
    postGrid.querySelector('.btn.show-more').addEventListener('click', function (){
      event.preventDefault();
      postGrid.querySelectorAll('.post-col').forEach( post => {
        post.style.display = "block";
      });
      this.style.display = "none";
    });
  });
}
